import type { OptionGenericType } from '../typeV2'

export const AC_VOLTAGE_RATING_BUCKET_FILTER_KEY_V2 = 'ac_voltage_rating_bucket'

export type ACVoltageMinimumOption = OptionGenericType<string> & {
  minimumVoltage: number
}

export const AC_VOLTAGE_MINIMUM_OPTIONS: ACVoltageMinimumOption[] = [
  { id: 'all', title: 'All', value: 'all', minimumVoltage: 0 },
  { id: 'gte_240', title: '\u2265 240V', value: '240', minimumVoltage: 240 },
  { id: 'gte_415', title: '\u2265 415V', value: '415', minimumVoltage: 415 },
]

export const getMinimumVoltageForPhase = (phaseType?: string): number => {
  if (phaseType === 'single_phase') return 240
  if (phaseType === 'three_phase' || phaseType === 'two_phase') return 415
  return 0
}

export const getDefaultVoltageFilterValue = (phaseType?: string): string => {
  const min = getMinimumVoltageForPhase(phaseType)
  if (min <= 0) return 'all'
  return String(min)
}

export const parseMinimumVoltageFromFilterValue = (rawValue: unknown): number => {
  if (rawValue === 'all' || rawValue === '' || rawValue == null) return 0
  const parsed = Number(rawValue)
  return Number.isFinite(parsed) ? parsed : 0
}

export const isVoltageRatingCompatible = (voltageRatingRaw: unknown, minimumVoltage: number): boolean => {
  if (minimumVoltage <= 0) return true
  const voltageRating = Number(voltageRatingRaw)
  if (!Number.isFinite(voltageRating)) return false
  return voltageRating >= minimumVoltage
}

// Kept for backward compatibility with existing imports, but prefer the new functions above.
// TODO: Remove these after all consumers are migrated.
export type ACVoltageBucketType = ACVoltageMinimumOption
export const AC_VOLTAGE_RATING_BUCKET_OPTIONS = AC_VOLTAGE_MINIMUM_OPTIONS
export const getVoltageBucketForRating = (voltageRatingRaw: unknown): ACVoltageMinimumOption | null => {
  const voltageRating = Number(voltageRatingRaw)
  if (!Number.isFinite(voltageRating)) return null
  return AC_VOLTAGE_MINIMUM_OPTIONS.find((opt) => opt.value !== 'all' && voltageRating >= opt.minimumVoltage) || null
}
export const getAllowedACVoltageBucketValuesForMinimum = (minimumVoltageRaw: unknown): string[] => {
  const min = Number(minimumVoltageRaw)
  if (!Number.isFinite(min) || min <= 0) return ['all']
  return [String(min)]
}
